import React from 'react';
import { getCataloguePath, getOfferPath } from '../trainingRoutes';

export default function TrainingHeader({ locale, offerKey }) {
  const otherLocale = locale === 'fr' ? 'en' : 'fr';
  const languageLabel = locale === 'fr' ? 'English' : 'Français';
  const languagePath = offerKey
    ? getOfferPath(otherLocale, offerKey)
    : getCataloguePath(otherLocale);

  return (
    <header className="training-header">
      <div className="training-header__inner">
        <a className="training-header__brand" href="/">
          <img src="/favicon.svg" alt="CSL BRANDS" width="64" height="40" />
        </a>
        <a className="training-header__language" href={languagePath} lang={otherLocale}>
          {languageLabel}
        </a>
      </div>
    </header>
  );
}
